





























































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { BookingWizardModule } from '@/store/modules/bookingWizard';
import PositionDto from '@/models/Positions/PositionDto';
import ShiftViewModel from '@/models/Shifts/ShiftViewModel';
import BookingRoleViewModel from '@/models/BookingRoles/BookingRoleViewModel';
import BreakDto from '@/models/Shared/BreakDto';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import ContactLocationDto from '@/models/ContactLocations/ContactLocationDto';

@Component({
    name: 'BookingWizardBookingRoleCreate'
})
export default class extends GiganautVueDialog {
 
    public dialog = false;
    //contactLocations: ContactLocationDto[] = [];
    startTime = "08:00";


    allowedStep(m: any) {
        return m % 15 === 0
    }

    @Watch('dialog')
    async onDialogChanged(val: boolean, oldVal: boolean) {
    await BookingWizardModule.cleanBookingRoleState(); 
    }

    get bookingRole() {
        return BookingWizardModule.newBookingRole;
    }

    get positions() {
        return BookingWizardModule.newBooking.location.rateCard.positions;
    }

    get desks() {
        return BookingWizardModule.newBookingOptions.desks;
    }

    get skills() {
        return BookingWizardModule.newBookingRole.rateCardPosition.position.skills;
    }

     get qualifications() {
        return BookingWizardModule.newBookingRole.rateCardPosition.position.qualifications;
    }

    get uniforms() {
        return BookingWizardModule.newBookingRole.rateCardPosition.position.uniforms;
    }

    get agencyUsers() {
      return BookingWizardModule.newBookingOptions.agencyUsers;
    }

    get contactLocations() {
        return BookingWizardModule.newBooking.location.contactLocations;
    }

    get currentContacts() {
        return BookingWizardModule.newBooking.location.contactLocations;
    }

    get currentPosition() {
        return BookingWizardModule.newBookingRole.rateCardPosition;
    }

    set currentPosition(value) {
       BookingWizardModule.updateNewBookingRolePosition(value);
    }

    get currentOwner() {
        return BookingWizardModule.newBookingRole.owner;
    }

    set currentOwner(value) {
        BookingWizardModule.updateNewBookingRoleOwner(value);
    }

    get currentContactLocation() {
        return BookingWizardModule.newBookingRole.contactLocation;
    }

    set currentContactLocation(value) {
        BookingWizardModule.updateNewBookingRoleContactLocation(value);
    }

    get currentPositionDescription() {
        return BookingWizardModule.newBookingRole.positionDescription;
    }

    set currentPositionDescription(value) {
        BookingWizardModule.updateNewBookingRolePositionDescription(value);
    }

    get currentSkills() {
        return BookingWizardModule.newBookingRole.skills;
    }

    set currentSkills(value) {
        BookingWizardModule.updateNewBookingRoleSkills(value);
    }

    get currentQualifications() {
        return BookingWizardModule.newBookingRole.qualifications;
    }

    set currentQualifications(value) {
        BookingWizardModule.updateNewBookingRoleQualifications(value);
    }

    get currentUniform() {
        return BookingWizardModule.newBookingRole.uniform;
    }

    set currentUniform(value) {
        BookingWizardModule.updateNewBookingRoleUniform(value);
    }

    get chargeRate() {
        return BookingWizardModule.newBookingRole.chargeRate;
    }

    set chargeRate(value) {
        BookingWizardModule.updateNewBookingRoleChargeRate(value);
    }

    get currentDesk() {
        return BookingWizardModule.newBookingRole.desk;
    }

    set currentDesk(value) {
        BookingWizardModule.updateNewBookingRoleDesk(value);
    }

    get currentUniformDescription() {
        return BookingWizardModule.newBookingRole.uniformDescription;
    }

    set currentUniformDescription(value) {
        BookingWizardModule.updateNewBookingRoleUniformDescription(value);
    }

    get currentQuantity() {
        return BookingWizardModule.newBookingRole.quantity;
    }

    set currentQuantity(value) {
        BookingWizardModule.updateNewBookingRoleQuantity(value);
    }

    get currentStartAtTime() {
        return BookingWizardModule.newBookingRole.startAtTime;
    }

    set currentStartAtTime(value) {
        BookingWizardModule.updateNewBookingRoleStartAtTime(value);
    }

    get currentEndAtTime() {
    return BookingWizardModule.newBookingRole.endAtTime;
    }

    set currentEndAtTime(value) {
        BookingWizardModule.updateNewBookingRoleEndAtTime(value);
    }

  get loading() {
    return BookingWizardModule.loadingDialog;
  }

  save() {
    if (!(this.$refs.form as any).validate()) {
        return;
    }
    //loop through the dates and create a shift
    const newBookingRole = BookingWizardModule.newBookingRole;
    for (let i = 0; i < BookingWizardModule.newBooking.dates.length; i++) {
        
        const dateString = BookingWizardModule.newBooking.dates[i];
        //console.log(dateString);
        const date = Date.parse(dateString);
        const shift = new ShiftViewModel();
        shift.startAtDate = dateString;
        shift.startAtTime = newBookingRole.startAtTime;
        shift.endAtTime = newBookingRole.endAtTime;
        shift.quantity = newBookingRole.quantity;

        shift.break = 20;
        newBookingRole.shifts.push(shift);
    }
    BookingWizardModule.addNewBookingRole(newBookingRole);
    BookingWizardModule.cleanBookingRoleState();
    this.dialog = false;
  }
}
